<template>
	<div class="search-app">
		<div class="detail-nav">
			<router-link to="/">
				<img src="images/index.png" />首页
			</router-link>
			<span>{{searchKey}}</span>
		</div>
		<div class="search-box">
			<div class="search-left">
				<div class="user-title">
					<span>搜索结果</span>
				</div>
				<div class="search-result" v-if="searchList && searchList.length > 0">
					<router-link
						v-for="(item,index) in searchList"
						:key="item.id"
						:to="{path:'/detail',query:{id:item.id}}"
					>
						<div>
	
							{{((currentPage-1)*10+index)+1}}.
							<em>【{{item.genre_name}}】</em>
							<span class="hello" v-html="item.title"></span>
						</div>
						<!-- <aside>
							{{((currentPage-1)*10+index)+1}}.
							<em>【{{item.name}}题】</em>
							<span v-html="item.title"></span>
						</aside>-->
					</router-link>
				</div>
				<div class="search-result" v-else style="text-align:center; padding:20px 0 0 0">暂无搜索结果</div>
				<div class="list-page">
					<el-pagination
						background
						layout="prev, pager, next"
						:total="count/10"
						:current-page="currentPage"
						prev-text="上一页"
						next-text="下一页"
						:hide-on-single-page="true"
						@current-change="changeCurrentPage"
					></el-pagination>
				</div>
			</div>
			<div class="search-right">
				<div class="search-right-top">
					<img src="/images/a3.jpg" alt />
					<div>
						<router-link
							title="教师公招"
							:to="{
							path:'/',
							query:{
								tid:3
							}
						}"
						>
							<img src="/images/se_1.png" alt />
							<p>教师公招</p>
						</router-link>
						<router-link
							title="教师资格证"
							:to="{
							path:'/',
							query:{
								tid:2
							}
						}"
						>
							<img src="/images/se_2.png" alt />
							<p>教师资格证</p>
						</router-link>
						<router-link
							title="事业单位"
							:to="{
							path:'/',
							query:{
								tid:4
							}
						}"
						>
							<img src="/images/se_3.png" alt />
							<p>事业单位</p>
						</router-link>
					</div>
				</div>

				<div class="search-right-news">
					<h3>
						最新资讯
						<a @click="openMoreArticle">更多</a>
					</h3>
					<p>
						<img src="/images/a4.png" alt />
					</p>
					<ol>
						<li
							v-for="(item,index) in searchArticle"
							:data-id="index+1"
							@click="openAeticle(item.id)"
						>{{item.name}}</li>
					</ol>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MathJax from '../../../Math.js'
	export default {
		name: "",
		data() {
			return {
				searchKey: "",
				searchList: [],
				count: "",
				currentPage: 1,
				limit: 10,
				searchArticle: [],
			};
		},
		methods: {
			changeCurrentPage(currentPage) {
				this.currentPage = currentPage;
				this.getSearchData(this.searchKey, currentPage, this.limit);
				window, scrollTo(0, 0);
			},
			getSearchData(title, page, limit) {
				this.$loading();
				var param = {
					name: title,
					page: page,
					limit: limit,
				};
				this.$api.searchAnswer(param).then(res => {
					//console.log(res)
					this.searchList = res.data.list;
					this.count = res.data.total;
					setTimeout(() => {
						this.$loading().close();
					}, 500);
				})
				return
				this.$post("search", param).then((res) => {
					
					this.searchArticle = res.article;
					
					this.currentPage = page;
					this.limit = limit;
					
				});
			},
			openAeticle(id) {
				window.open(this.szUrl + "svdw-wz/" + id, "_blank");
			},
			openMoreArticle() {
				window.open(this.szUrl + "jszp", "_blank");
			},
		// 	 formatMath() {
    //   let that = this;
    //   setTimeout(function () {
    //     that.$nextTick(function () {
    //       if(MathJax.isMathjaxConfig){//判断是否初始配置，若无则配置。
    //         MathJax.initMathjaxConfig();
    //       }
    //       MathJax.MathQueue('hello');//传入组件id，让组件被MathJax渲染

		// 	 })
    //   },500);
    // }

		},

		watch: { // 监视latex的变化
          searchList() {
            this.$nextTick(function () { // Vue的DOM渲染是异步的
              if (MathJax.isMathjaxConfig) { // 是否配置MathJax
                  MathJax.initMathjaxConfig()
              }
              MathJax.MathQueue('hello') // 渲染对应的id/class
            })
          }
        },
		created() {
			// this.formatMath()
			this.searchKey = this.$route.query.key;

			this.getSearchData(this.searchKey, 1, 10);
	
			 
		},
	};
</script>

<style>
	.search-box {
		display: flex;
		overflow: hidden;
		margin-top: 20px;
	}
	.search-left {
		flex: 1;
		padding: 0 30px 30px 30px;
		background-color: #fff;
	}
	.search-right {
		width: 340px;
		margin-left: 20px;
	}
	.search-result a {
		display: block;
		padding: 30px 0;
		border-bottom: 1px dashed #ebebeb;
		font-size: 16px;
		color: #333;
	}
	.search-result a:hover {
		color:#e60012;
	}
	.search-right-top {
		background-color: #fff;
	}
	.search-right-top a {
		display: inline-block;
		width: 33.3%;
		text-align: center;
		padding: 20px 0;
	}
	.search-right-top a:hover {
		opacity: 0.7;
	}
	.search-right-top p {
		margin-top: 5px;
	}
	.search-right-news {
		background-color: #fff;
		margin-top: 30px;
		padding: 30px;
	}
	.search-right-news h3 {
		padding-bottom: 20px;
		color: #333;
	}
	.search-right-news h3 a {
		float: right;
		font-size: 14px;
		color: #999;
	}
	.search-right-news h3 a:hover {
		color:#e60012;
	}
	.search-right-news img {
		width: 100%;
	}
	.search-right-news li {
		margin-top: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding-left: 25px;
		position: relative;
	}
	.search-right-news li:hover {
		color:#e60012;
		cursor: pointer;
	}
	.search-right-news li::before {
		content: attr(data-id);
		display: block;
		width: 16px;
		height: 16px;
		text-align: center;
		line-height: 16px;
		font-size: 12px;
		background-color: #ebebeb;
		color:#e60012;
		border-radius: 100%;
		position: absolute;
		left: 0;
		top: 4px;
	}
	.search-right-news li:nth-child(1):before {
		background-color: #ff6c6c;
		color: #fff;
	}
	.search-right-news li:nth-child(2):before {
		background-color: #ff9438;
		color: #fff;
	}
	.search-right-news li:nth-child(3):before {
		background-color:#e60012;
		color: #fff;
	}
</style>
